function angularReactSelectorDirective($location) {
  return {
    restrict: 'A',
    link(scope) {
      // eslint-disable-next-line no-param-reassign
      scope.shouldRenderAngularComponents = false;

      scope.$watch(
        function getPath() {
          return $location.path();
        },
        function updateShouldRender(newPath) {
          const sanitizedPath = String(newPath).trim();
          // eslint-disable-next-line no-param-reassign
          scope.shouldRenderAngularComponents = !sanitizedPath || sanitizedPath === '/';
        }
      );
    }
  };
}

angularReactSelectorDirective.$inject = ['$location'];

export default angularReactSelectorDirective;
